export interface AppVersion {
  version: string;
  build: string;
}

export const APP_VERSION: AppVersion = {
  version: '2.0.18',
  build: '2026-11-02', 
};